import { useMemo } from "react";
import { InputLabel, FormControl, Select, MenuItem } from "@material-ui/core";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { shouldBeLocked } from "../utils/Roles";
const useStyles = makeStyles({
  label: {
    position: "relative",
    paddingRight: "25px",
    "&div": {
      marginTop: 0,
      "&:before": {
        bottom: "5px",
      },
      "&:after": {
        bottom: "5px",
      },
      svg: {
        top: "0",
      },
    },
  },
});

//Refactored to not use the labelWidth and inputLabel as they were not working. Test for a while with this change before removing all the inputLabels and labelWidths
const SingleDropDownOfficer = ({
  value = {},
  options = [],
  title = "",
  classStyle = "",
  inputLabel = {},
  labelWidth,
  stateName = "",
  handleChange = () => {
    alert("Handle change function not passed to SingleDropDownOfficer");
  },
  disabled = false,
  userRoles = [],

  ...props
}) => {
  const memoizedLocked = useMemo(
    () => shouldBeLocked(disabled, props?.canEdit, userRoles),
    [disabled, props?.canEdit, userRoles]
  );
  const classes = useStyles();

  return (
    <FormControl variant="standard" className={classStyle}>
      <InputLabel
        shrink={true}
        className={classes.label}
        data-cy={title + "-label"}
        ref={inputLabel}
        id={title + "-label"}
      >
        {title}
      </InputLabel>
      <Select
        disabled={memoizedLocked}
        data-cy={title + "-select"}
        labelId={title + "-label"}
        id={title + "-id"}
        name={stateName}
        defaultValue={value}
        value={
          !value || options?.length === 0
            ? ""
            : options[options.findIndex(option => option?.id === value?.id)]
        }
        native={false}
        renderValue={() =>
          `${value?.personalAttribute?.lastName}, ${value?.personalAttribute?.firstName}`
        }
        onChange={handleChange}
        style={{ marginTop: "0px" }}
      >
        <MenuItem
          data-cy="person-type-select-blank-menu-item"
          key={"no-person-type"}
          value=""
        ></MenuItem>
        {options.map(option => (
          <MenuItem key={option.id} value={option}>
            {option?.deptAttribute?.ori?.abbreviation}-
            {option?.deptAttribute?.badge}:{" "}
            {option?.personalAttribute?.lastName},{" "}
            {option?.personalAttribute?.firstName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

SingleDropDownOfficer.propTypes = {
  value: PropTypes.object,
  options: PropTypes.array,
  title: PropTypes.string,
  classStyle: PropTypes.string,
  inputLabel: PropTypes.object,
  labelWidth: PropTypes.number,
  stateName: PropTypes.string,
  handleChange: PropTypes.func,
  disabled: PropTypes.bool,
  userRoles: PropTypes.array,
};

export default SingleDropDownOfficer;
